export default "__VITE_ASSET__8d345dab__"